import React from 'react'
import { withAllContexts } from '../../AllContextsWrapper';
import EditClient from './Client/EditClient';
import PullToRefresh from 'react-simple-pull-to-refresh';
import { AppBar, Dialog, Typography, Toolbar, IconButton, Slide, Box, TextField, CircularProgress, InputAdornment, Card, Avatar } from '@mui/material';

import {
  Close as CloseIcon,
  ModeEditOutlined as ModeEditOutlinedIcon,
  Search as SearchIcon,
  Person as PersonIcon,
  Phone as PhoneIcon,
  Email as EmailIcon
} from '@mui/icons-material';



class ClientsModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      clients: null,
      editClient: null,
      search: ""
    };
  }

  closeModal = () => {
    window.history.back();
  }

  getClients = (resolve, reject) => {
    if(!resolve) resolve = () => {};
    if(!reject) reject = () => {};

    this.props.socketIO.socket.emit('client:getAll', (response) => {
      if (response.success === true) {
        this.setState({
          clients: response.data
        }, ()=> {
          resolve();
        })
      } else {
        this.setState({
          clients: null
        }, () => {
          reject();
        })
      }
    });
  }

  closeEdit = () => {
    this.setState({ editClient: null });
    this.getClients();
    window.history.back();
  }

  editClient = (client) => {
    this.setState({ editClient: client });
    this.props.app.functions.pushHistoryState(`/clients/${client.id}`);
  }

  afterOpenModal = () => {
    this.getClients();
  }

  componentDidMount() {
    this.getClients();
  }

  handlePullToRefresh = () => {
    return new Promise((resolve, reject) => {
      this.getClients(resolve, reject);
    });
  }

  render() {
    let clients = this.state.clients;
    if (clients && this.state.search.length > 0) {
      const searchLower = this.state.search.toLowerCase();
      clients = clients.filter(
        o => {
          return Object.keys(o).some(k => {
            if (o[k] !== null && o[k] !== undefined && k !== "id") {
              const val = String(o[k]).toLowerCase();
              return val.includes(searchLower);
            }
            return false;
          })
        }
      )
    }

    const isLoading = this.state.clients === null;

    return (
      <Dialog
        fullScreen
        open={this.props.app.state.shownComponent === 'clients'}
        onClose={this.closeModal}
        TransitionComponent={Transition}
      >
        <AppBar 
          sx={{ 
            position: 'sticky', 
            top: 0, 
            background: 'white', 
            color: 'gray.900',
            boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1)',
            zIndex: 1100
          }}
        >
          <Toolbar sx={{ justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <IconButton
                edge="start"
                onClick={this.closeModal}
                aria-label="close"
                sx={{ color: 'gray.600' }}
              >
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 1, fontWeight: 700, color: 'gray.900' }} variant="h6">
                {this.state.editClient ? "Upraviť klienta" : "Zoznam klientov"}
              </Typography>
            </Box>
          </Toolbar>
        </AppBar>

        <Box sx={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column', bgcolor: '#F9FAFB' }}>
          <PullToRefresh
            onRefresh={this.handlePullToRefresh}
            pullingContent=""
            refreshingContent={
              <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
                <CircularProgress size={24} />
              </Box>
            }
          >
            <Box sx={{ p: { xs: 2, md: 4 }, maxWidth: '800px', mx: 'auto', width: '100%' }}>
              {this.state.editClient ? (
                <EditClient
                  client={this.state.editClient}
                  closeEdit={this.closeEdit}
                />
              ) : (
                <>
                  {/* Search Bar */}
                  <div className="mb-6 sticky top-2 z-10">
                    <TextField
                      fullWidth
                      placeholder="Hľadať podľa mena, telefónu alebo emailu..."
                      variant="outlined"
                      value={this.state.search}
                      onChange={(e) => this.setState({ search: e.target.value })}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon sx={{ color: 'gray.400' }} />
                          </InputAdornment>
                        ),
                        sx: {
                          bgcolor: 'white',
                          borderRadius: '12px',
                          '& fieldset': { borderColor: 'rgba(0,0,0,0.1)' },
                          '&:hover fieldset': { borderColor: 'rgba(0,0,0,0.2)' },
                          boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
                        }
                      }}
                    />
                  </div>

                  {isLoading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 10 }}>
                      <CircularProgress />
                    </Box>
                  ) : (
                    <div className="space-y-4 pb-20">
                      {clients && clients.length > 0 ? (
                        clients.map(client => (
                          <Card 
                            key={client.id}
                            onClick={() => this.editClient(client)}
                            sx={{ 
                              p: 2, 
                              borderRadius: '16px', 
                              cursor: 'pointer',
                              border: '1px solid rgba(0,0,0,0.05)',
                              boxShadow: 'none',
                              '&:hover': {
                                boxShadow: '0 10px 15px -3px rgb(0 0 0 / 0.1)',
                                transform: 'translateY(-2px)',
                                borderColor: 'primary.light'
                              },
                              transition: 'all 0.2s ease'
                            }}
                          >
                            <div className="flex items-center gap-4">
                              <Avatar sx={{ bgcolor: 'blue.50', color: 'blue.600', width: 48, height: 48 }}>
                                <PersonIcon />
                              </Avatar>
                              <div className="flex-1 min-w-0">
                                <h4 className="font-bold text-gray-900 truncate">{client.name || 'Bez mena'}</h4>
                                <div className="flex flex-wrap gap-x-4 gap-y-1 mt-1">
                                  {client.phone && (
                                    <div className="flex items-center gap-1 text-xs text-gray-500">
                                      <PhoneIcon sx={{ fontSize: 14 }} />
                                      {client.phone}
                                    </div>
                                  )}
                                  {client.email && (
                                    <div className="flex items-center gap-1 text-xs text-gray-500">
                                      <EmailIcon sx={{ fontSize: 14 }} />
                                      {client.email}
                                    </div>
                                  )}
                                </div>
                              </div>
                              <IconButton size="small" sx={{ color: 'gray.400' }}>
                                <ModeEditOutlinedIcon fontSize="small" />
                              </IconButton>
                            </div>
                          </Card>
                        ))
                      ) : (
                        <div className="text-center py-20 bg-white rounded-2xl border-2 border-dashed border-gray-100">
                          <p className="text-gray-400">Nenašli sa žiadni klienti</p>
                        </div>
                      )}
                    </div>
                  )}
                </>
              )}
            </Box>
          </PullToRefresh>
        </Box>
      </Dialog>

    );
  }
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


export default withAllContexts(ClientsModal);
